import React, { useMemo, useState } from 'react'
import Scroll from 'react-scroll'
import MovieTimes from '../../MovieInformation/MovieTimes'
import PosterFormatItem from '../../PosterFormatItem'
import Actors from '../../MovieInformation/Actors'
import Directors from '../../MovieInformation/Directors'
import MovieLength from '../../MoviesGeneral/MovieLength'
import DetailsButton from './DetailsButton'
import MovieDetails from '../../MovieDetails'
import PerformanceSectionWithoutMovieTimes from '../../PerformancePage/PerformanceSectionWithoutMovieTimes'
import { SiteSlidebarRight, SiteSlidebarRightSecond } from '../../General/SiteSlidebars'
import { trackMovieDetailsClose, trackMovieDetailsOpen, trackMoviePerformanceClose, trackMoviePerformanceOpen } from '../../tracking'
import Translation from '../../General/Translation'
import PerformanceSection from '../../PerformancePage/PerformanceSection'
import getTranslationTime from '../../functions/getTranslationTime'
import ShareButtons from '../../General/ShareButtons'
import TrailerSmall from '../../Trailer/TrailerSmall'
import getBackgroundsUrlsObj from '../../functions/getBackgroundsUrlsObj'
import getImageUrl from '../../functions/getImageUrl'
import getMomentDateObj from '../../functions/getMomentDateObj'
import getMomentNow from '../../functions/getMomentNow'
import Description from '../../MovieInformation/Description'
import FskWrapper from '../../MovieInformation/FskWrapper'
import ItemPerformancesContainer from '../../PosterFormatItem/ItemPerformancesContainer'
import MovieTimesContainer from '../../MovieInformation/MovieTimesContainer'

let Element = Scroll.Element;

const MovieListItemStandard = ({
    itemData, 
    itemLink,
    itemDetailsOpen, 
    scrollToPosition, 
    id, 
    hideCinemaSelector,
    isMobile,
    programOverviewListStyle,
    itemsData, 
    isOverview, 
    translation,
    closingDetails, 
    showMobileMovieTimes, 
    toggleMovieDatesOnMobileView, 
    toggleMovieTimesOnMobileView, 
    detailsStyling,
    openItemDetails, 
    overviewFilterIgnoreOnPerformances,
    dayFilters,
    closeItemDetails, 
    currentDateActive,
    displaySidebarRight,
    informationStyling,
    theme,
    displaySidebarRightSecond,
    isSingleMovie,
    performancePageOpen, 
    ignoreAttributesForPerformanceFilter,
    activePerformance, 
    attributeStyling,
    onOpenPerformancePage, 
    onClosePerformancePage,
    currentBrowserWidth,
    queryStringValues,
    clusterCinemaActive,
    clusterCinemaOption,
    activeCinema,
    currentCinemaType
}) => {
    const {title, images, descriptionShort, fsk, actors, subTitle, directors, length, performances, technologyAttributes, titleDisplay, startingDate, trailerURL, origTitle, pk, genres, limitations } = itemData;
    const {showCountdown, visibleFrom} = limitations

    const { timezone } = translation
    const [fallbackInUse, setFallback] = useState(false)
    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
        )
    const {finalImageURl, imageUrl, position} = getImageUrl(backgroundsObj.performance, isMobile, false, true)
    const containsOv = _.find(technologyAttributes, attribute => {
        return attribute.id === 'owefwefewfv'
    })

    let purchaseblePerformances =  _.filter(performances, performance => {
        const {limitations} = performance

        if(limitations.visibleFrom) {
            // return new Date().getTime() - 5256700000 > limitations.visibleFrom
            const performanceDate = getMomentDateObj(limitations.visibleFrom, timezone)

            return getMomentNow(timezone).isAfter(performanceDate)
        } else {
            return true
        }
    })

    const currentTitle = titleDisplay ? titleDisplay : containsOv && origTitle ? origTitle : title 
    const isOpen = itemDetailsOpen ? ' is-open' : ''
    const closeDetails = closingDetails ? ' closing-details' : '' // ToDo: Wird noch verwendet?
    const additionalClass = showMobileMovieTimes ? ' show-on-mobile' : ' hide-on-mobile'
    const formatedDate = getTranslationTime('performanceDates', translation, startingDate)
    const hintText = (performances[0] && purchaseblePerformances[0]) ? <Translation id="performances" trans={translation}>Vorstellungen</Translation> : null

    const eventOrigins = {
        listitem:                 'Programmübersicht, Liste, Filmelement',
        details:                  'Programmübersicht, Liste, Film Details',
        detailsSlidebar:          'Programmübersicht, Liste, Film Details/rechte Slidebar'
    }

    let styles = {    
        objectPosition: position
    }

    return (
        <div id={'movie-item'} className={"movie-item " + theme.toLowerCase() + isOpen + closeDetails}>
            <Element name={scrollToPosition  + ' movieInformation'}></Element>

            <div className="movie-item-content">
                <div className="movie-item-background-image-wrapper theme-radius-posters-full">
                    <img 
                        src={finalImageURl} 
                        style={styles}
                        className='movie-item-background-image theme-radius-posters-full'
                        alt={'Background'} 
                        onError={({ currentTarget }) => {
                            if(fallbackInUse) {
                                currentTarget.onerror = null; 
                                currentTarget.src = '';
                            } else {
                                setFallback(true)
                                currentTarget.onerror = null; 
                                currentTarget.src = imageUrl;
                            }
                        }}
                    />
                </div>

                <div className="movie-item-ambient slide-item">
                    <PosterFormatItem
                        itemID={id}
                        showFSK={true}
                        itemData={itemData}
                        translation={translation}
                        isMobile={isMobile}
                        isOverview={isOverview}
                        ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
                        onClickItem={trackMovieDetailsOpen(openItemDetails, eventOrigins.listitem)}
                        toggleMovieTimesOnMobileView={toggleMovieTimesOnMobileView}
                    />
                   {(currentBrowserWidth >= 1220 || (currentBrowserWidth >= 480 && programOverviewListStyle === 'colored_blocks')) && <DetailsButton 
                        movieId={id}
                        movieTitle={currentTitle} 
                        scrollToPosition={scrollToPosition}
                        translation={translation}
                        itemDetailsOpen={itemDetailsOpen} 
                        openItemDetails={trackMovieDetailsOpen(openItemDetails, eventOrigins.listitem)} 
                        closeItemDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.listitem)} 
                    />}
                </div>
               {currentBrowserWidth < 1220 && programOverviewListStyle !== 'colored_blocks' && <DetailsButton 
                    movieId={id}
                    movieTitle={currentTitle} 
                    scrollToPosition={scrollToPosition}
                    translation={translation}
                    itemDetailsOpen={itemDetailsOpen} 
                    openItemDetails={trackMovieDetailsOpen(openItemDetails, eventOrigins.listitem)} 
                    closeItemDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.listitem)} 
                />}

                <div className={'information'}>
                    {!isSingleMovie && <h2 className={'title title-xlarge-bold-overview'}>
                        {currentTitle}
                    </h2>}
                    {subTitle && <p className='title-slider subtitle'>{subTitle}</p>}
                    {(actors.length !== 0 || directors) && <div className={'actors'}>
                        <Actors actors={actors} translation={translation} />
                        <Directors directors={directors} actors={actors} translation={translation}/>
                    </div>}
                     <div className="fsk-and-trailer">
                        {trailerURL && <TrailerSmall 
                            trailerURL={trailerURL}
                            fsk={fsk}
                            translation={translation}
                        />}
                        <div className='fsk-length-wrapper'>
                            <MovieLength length={length} translation={translation}/>
                            <FskWrapper labelFsk={true} fsk={fsk}/>
                            {currentBrowserWidth < 480 && programOverviewListStyle === 'colored_blocks' && <DetailsButton 
                                movieId={id}
                                movieTitle={currentTitle} 
                                scrollToPosition={scrollToPosition}
                                translation={translation}
                                itemDetailsOpen={itemDetailsOpen} 
                                openItemDetails={trackMovieDetailsOpen(openItemDetails, eventOrigins.listitem)} 
                                closeItemDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.listitem)} 
                            />}

                        </div>
                    </div>
                    <Description className="text-light" translation={translation} movieData={itemData}/>
                    <Element name={scrollToPosition + ' openMovieInformation'}></Element>
                        
                    <div className='row-flex-information no-border'>
                        {itemLink && <ShareButtons 
                            url={itemLink}
                            title={currentTitle}
                            description={descriptionShort}
                            translation={translation}
                        />}
                    </div>
                   {currentBrowserWidth >= 1220 && <MovieTimesContainer
                        dayFilters={dayFilters}
                        activeCinema={activeCinema}
                        activePerformance={activePerformance}
                        hideCinemaSelector={hideCinemaSelector}
                        verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                        onClick={toggleMovieDatesOnMobileView}
                        additionalClass={additionalClass}
                        movieData = {itemData}
                        currentDateActive = {currentDateActive}
                        scrollToPosition={scrollToPosition}
                        queryStringValues={queryStringValues}
                        onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, 'eventOrigins.listitem')}
                    />}
                </div>
                {hintText && <p className="showtimes-title typo-color-muted text-small-medium">{hintText}</p>}
                
                <ItemPerformancesContainer 
                    itemData={itemData}
                    showMobileMovieTimes={showMobileMovieTimes}
                    isOverview={isOverview} 
                    attributeStyling={attributeStyling}
                    clusterCinemaActive={clusterCinemaActive}
                    clusterCinemaOption={clusterCinemaOption}
                    dayFilters={dayFilters}
                    activeCinema={activeCinema}
                    scrollToPosition={scrollToPosition} 
                    queryStringValues={queryStringValues}
                    currentCinemaType={currentCinemaType}
                    additionalClass={' ' + pk}
                    performances={performances} 
                    technologyAttributes={technologyAttributes} 
                    onClick={toggleMovieTimesOnMobileView}
                    currentBrowserWidth={currentBrowserWidth}
                />
                
                {currentBrowserWidth < 1220 && <MovieTimesContainer
                    dayFilters={dayFilters}
                    activeCinema={activeCinema}
                    activePerformance={activePerformance}
                    hideCinemaSelector={hideCinemaSelector}
                    verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    onClick={toggleMovieDatesOnMobileView}
                    additionalClass={additionalClass}
                    movieData = {itemData}
                    currentDateActive = {currentDateActive}
                    scrollToPosition={scrollToPosition}
                    queryStringValues={queryStringValues}
                    onOpenIframe={trackMoviePerformanceOpen(onOpenPerformancePage, 'eventOrigins.listitem')}
                />}
            </div>
            {!displaySidebarRightSecond && performancePageOpen && activePerformance.movieId === id && <PerformanceSectionWithoutMovieTimes
                itemID={id}
                translation={translation}
                theme={theme}
                activePerformance={activePerformance}
                isMobile={isMobile}
                moviesData={itemsData}
                scrollToPosition={scrollToPosition}
                onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage)}
            />}

            {displaySidebarRightSecond && performancePageOpen && activePerformance.movieId === id && <SiteSlidebarRightSecond>
                <PerformanceSection
                    informationStyling={informationStyling}
                    isMobile={isMobile}
                    queryStringValues={queryStringValues}
                    verviewFilterIgnoreOnPerformances={overviewFilterIgnoreOnPerformances}
                    itemID={id}
                    translation={translation}
                    activePerformance={activePerformance}
                    moviesData={itemsData}
                    theme={theme}
                    performancePageMovieTimes={true}
                    scrollToPosition={scrollToPosition + ' openMovieInformation'}
                    currentDateActive={currentDateActive}
                    backgroundImage={backgroundsObj.performance}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                    onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
                />
            </SiteSlidebarRightSecond>}

            <Element name={scrollToPosition + ' movieDetails'}></Element>

            {!displaySidebarRight && itemDetailsOpen && 
                <MovieDetails 
                    itemID={id}
                    translation={translation}
                    moviesData={itemsData}
                    detailsStyling={detailsStyling}
                    isMobile={isMobile}
                    theme={theme}
                    trailerImage={backgroundsObj.ambient}
                    attributeStyling={attributeStyling}
                    backgroundImage={backgroundsObj.details}
                    scrollToPosition={scrollToPosition}
                    onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.details)}
                />
            }

            {displaySidebarRight && itemDetailsOpen &&
                <SiteSlidebarRight>
                    <div className="site-slidebar-overlay accent-color-background-half-transparent" onClick={closeItemDetails} />

                    <div className="site-slidebar-content accent-color-background-half-transparent">
                        <MovieDetails 
                            itemID={id}
                            translation={translation}
                            trailerImage={backgroundsObj.ambient}
                            moviesData={itemsData}
                            attributeStyling={attributeStyling}
                            detailsStyling={detailsStyling}
                            theme={theme}
                            isMobile={isMobile}
                            backgroundImage={backgroundsObj.details}
                            scrollToPosition={scrollToPosition}
                            onCloseDetails={trackMovieDetailsClose(closeItemDetails, eventOrigins.detailsSlidebar)}
                        />
                    </div>

                </SiteSlidebarRight>
            }
        </div>
    )

}
export default MovieListItemStandard